/**
 * pollRefused.js — PROD-270, patient half.
 *
 * A poll the server REFUSED (403) is over: asking again gets the same answer, so the
 * loop ends at once instead of running out its backoff schedule. Any other failure
 * (a 500, a timeout, no network) is transient and the poll keeps going.
 *
 * Same shape as orella-md-panel's `pollRefused` (src/services/api.js, a195295). The two
 * repos share no package; keep the two definitions identical by hand.
 *
 * No imports: scripts/test-poll-refusal.mjs loads this in node.
 */
export const pollRefused = (e) => e?.status === 403
